<template>
  <div>
    <b-tabs pills card :vertical="!isMobileViewport" class="inc-cpt-detail-all">
    <b-tab :active="tabActive=='products'" v-if="configTabs.products && !hideProducts">
      <template #title>
        <span v-b-tooltip.hover title="Seleccionar productos">
          <AppIcon name="upc-scan" label="Productos" font-scale="1.5" />
        </span>
      </template>
      <b-card-text>
        <DetailProducts :customer_id="customer_id" 
                        :price_list_id="price_list_id"
                        :reason_id="reason_id"
                        :disable-customer-price-list-fallback="disableCustomerPriceListFallback"
                        @load-detail="loadProducts($event)" 
                        :detailEdit="detail.products"
                        :editPrice="editPrice"
                        :validStock="false"
                        :showDiscount="true"
                        :onlyDiscount="onlyDiscountProduct"
                        :key="'detailInvoiceProducts_' + forceUpdate"
                        :forceUpdate="forceUpdate"
                        :validItemDuplicated="validItemDuplicatedProduct"
                        :barcodeAddAutomatic="barcodeAddAutomaticProduct"
                        :barcodeConfirm="barcodeConfirmProduct"
                        :iva-conditions="ivaConditions"
                        :not-iva="notIva"
                        :methodPayment="methodPayment"/>
      </b-card-text>
    </b-tab>

    <b-tab :active="tabActive=='productsCompound'" v-if="configTabs.productsCompound && !hideProductsCompound">
      <template #title>
        <span v-b-tooltip.hover title="Seleccionar productos compuestos">
          <AppIcon name="puzzle" label="Productos Compuestos" font-scale="1.5" />
        </span>
      </template>
      <b-card-text>
        <DetailProductsCompound :customer_id="customer_id" 
                                :price_list_id="price_list_id"
                                :disable-customer-price-list-fallback="disableCustomerPriceListFallback"
                                @load-detail="loadProductsCompound($event)" 
                                :detailEdit="detail.productsCompound"
                                :editPrice="editPrice"
                                :validStock="false"
                                :showDiscount="true"
                                :key="'detailInvoiceProductsCompound_' + forceUpdate"
                                :forceUpdate="forceUpdate"
                                :validItemDuplicated="validItemDuplicatedProduct"
                                :iva-conditions="ivaConditions"
                                :not-iva="notIva"/>
      </b-card-text>
    </b-tab>

    <b-tab :active="tabActive=='services'" v-if="configTabs.services && !hideServices">
      <template #title>
        <span v-b-tooltip.hover title="Seleccionar servicios">
          <AppIcon name="design_services" label="Servicios" font-scale="1.5" />
        </span>
      </template>
      <b-card-text>
        <DetailServices :customer_id="customer_id" 
                        :price_list_id="price_list_id"  
                        :disable-customer-price-list-fallback="disableCustomerPriceListFallback"
                        @load-detail="loadServices($event)"
                        :details="detail.services"                                                
                        :isEdit="true"
                        :isInvoice="true"
                        :date_init="moment().format('MM-DD-YYYY')"
                        :key="'detailInvoiceServices_' + forceUpdate"
                        :forceUpdate="forceUpdate"
                        :iva-conditions="ivaConditions"
                        :not-iva="notIva"/>
      </b-card-text>
    </b-tab>
    
    <b-tab :active="tabActive=='concepts'" title="Conceptos" v-if="!hideConcepts">
      <template #title>
        <span v-b-tooltip.hover title="Seleccionar conceptos">
          <AppIcon name="list-ul" label="Conceptos" font-scale="1.5" />
        </span>
      </template>
      <b-card-text>
        <DetailConcepts :customer_id="customer_id" 
                        @load-detail="loadConcepts($event)"                        
                        :details="detail.concepts"             
                        :isEdit="true"
                        :key="'detailInvoiceConcepts_' + forceUpdate"
                        :forceUpdate="forceUpdate"
                        :validItemDuplicated="validItemDuplicatedConcept"
                        :iva-conditions="ivaConditions"
                        :not-iva="notIva"/>
      </b-card-text>
    </b-tab>
    </b-tabs>
  </div>
</template>
<script>
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import DetailProducts from '@/components/inc/cpbtDetail/detailProducts'  
  import DetailProductsCompound from '@/components/inc/cpbtDetail/detailProductsCompound'  
  import DetailServices from '@/components/inc/cpbtDetail/detailServices'  
  import DetailConcepts from '@/components/inc/cpbtDetail/detailConcepts'  
  import moment from 'moment'
  import Helper from '@/handler/helper'
  import Param from '@/config/parameters'
  import serviceAPI from './services'

  export default {
    props: {
      customer_id:{
        type: Number,
        required: true,
      },
      price_list_id:{
        type: Number,
        default: 0,
      },   
      reason_id: {
        type: Number,
        default: 0,        
      },
      disableCustomerPriceListFallback: {
        type: Boolean,
        default: false,
      },
      detailProducts:{
        type: [Object, Array],
        default: () => [],
      },      
      detailProductsCompound:{
        type: [Object, Array],
        default: () => [],
      },            
      detailServices:{
        type: [Object, Array],
        default: () => [],
      },      
      detailConcepts:{
        type: [Object, Array],
        default: () => [],
      },        
      hideConcepts: {
        type: Boolean,
        default: true,
      },
      // pestaña a mostrar al abrir (products | productsCompound | services | concepts);
      // si no se indica o está oculta, se usa el orden habitual
      initialTab: {
        type: String,
        default: '',
      },
      hideProducts: {
        type: Boolean,
        default: false,
      },
      hideProductsCompound: {
        type: Boolean,
        default: false,
      },
      hideServices: {
        type: Boolean,
        default: false,
      },
      onlyDiscountProduct: {
        type: Boolean,
        default: false,        
      },    
      forceUpdate: {
        type: Number,
        default: 0,
      },    
      validItemDuplicatedProduct: {
        type: Boolean,
        default: true,
      },
      validItemDuplicatedConcept: {
        type: Boolean,
        default: true,
      },      
      barcodeAddAutomaticProduct: {
        type: Boolean,
        default: false,
      },
      barcodeConfirmProduct: {
        type: Boolean,
        default: false,
      },
      editPrice: {
        type: Boolean,
        default: true,        
      },
      notIva: {
        type: Boolean,
        default: false,
      },
      methodPayment:{
        type: [Object, Array],
        default: () => [],
      },                     
    },
    components: {      
      DetailProducts,  
      DetailProductsCompound,
      DetailServices,
      DetailConcepts,     
    }, 
    data: () => {
      return {          
        ivaConditions: [],
        configTabs: {
          products: false,
          productsCompound: false,
          services: false,
          concepts: false,
        },
        detail: {
          products: [],
          productsCompound: [],
          services: [],
          concepts: [],
        },      
        detailReturn: [],
        // Tabs verticales (una debajo de otra) solo en desktop; en mobile
        // pasan a horizontales (una al lado de otra), como cualquier b-tabs
        // sin el prop `vertical`.
        isMobileViewport: false,
      }
    },
    computed: {
      tabActive() {        
        if(this.initialTab == 'concepts' && !this.hideConcepts) {
          return 'concepts'
        }
        if(this.configTabs.products && !this.hideProducts) {
          return 'products'
        }
        if(this.configTabs.productsCompound && !this.hideProductsCompound) {
          return 'productsCompound'
        }
        if(this.configTabs.services && !this.hideServices) {
          return 'services'
        }
        if(!this.hideConcepts) {
          return 'concepts'
        }        
      },
    },
    mounted() {
      var modulesActive = Session.getSession().auth.user.permissions.modules
      
      modulesActive.forEach(element => {
        if(element.id == Modules.PRODUCTOS) {
          this.configTabs.products = true
          this.configTabs.productsCompound = Helper.hasParametersAccess(Param.P30)
        }

        if(element.id == Modules.SERVICIOS) {
          this.configTabs.services = true
        }                  
      })

      this.detail.products = this.detailProducts
      this.detail.productsCompound = this.detailProductsCompound
      this.detail.services = this.detailServices
      this.detail.concepts = this.detailConcepts

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadIvaConditions()
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      loadIvaConditions() {
        serviceAPI.obtenerIvaConditions()
          .then((response) => { this.ivaConditions = response.data || [] })
          .catch(() => { this.ivaConditions = [] })
      },
      loadProducts(event) {
        this.detail.products = event
        this.$emit('load-detail-products', this.detail.products)            
      },
      loadProductsCompound(event) {        
        this.detail.productsCompound = event
        this.$emit('load-detail-products-compound', this.detail.productsCompound)            
      },      
      loadServices(event) {
        this.detail.services = event
        this.$emit('load-detail-services', this.detail.services)            
      },
      loadConcepts(event) {
        this.detail.concepts = event
        this.$emit('load-detail-concepts', this.detail.concepts)            
      }
    }     
  }
</script>
<style>
  .inc-cpt-detail-all .card-header {
    padding: 0px;
  }
  .inc-cpt-detail-all .nav-link {
    padding: 8px 6px;
  }
  .inc-cpt-detail-all > .col-auto {
    padding-left: 2px;
    padding-right: 2px;
  }
</style>
